module.exports = __webpack_public_path__ + "images/kurtosis-02-desktop.png";